import React, { useEffect, useState } from 'react';
import { Grid, Tooltip, IconButton, withStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useStoreState, useStoreActions } from 'easy-peasy';
import moment from 'moment';
import ProceduresAddUpdate from '../../components/procedures/dialogProceduresAddUpdate';
import {
  globalPageTypeEntity,
  globalAssoSearchListingTypeEntity,
} from '../../constants/applicationConstants';
import DisplayBreadcrumbs from '../../components/displayBreadcrumbs/displayBreadcrumbs';
import styles from './procedures.module.scss';
import AddBoxIcon from '@material-ui/icons/AddBox';
// import ArchiveIcon from '@material-ui/icons/Archive';
import SyncAltIcon from '@material-ui/icons/SyncAlt';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import CustomListing from '../../components/customListing/CustomListing';
import FilterSection from '../../components/filterSections/FilterSection';
import { sortByField } from '../../submodule';
import { stringConstants } from '../../constants/stringConstants';

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    marginTop: '3px',
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

const useStyles = makeStyles({
  filterContainer: {
    padding: '30px 20px 10px 20px',
    fontSize: '20px',
    fontWeight: '600',
  },
  filterIconPopover: {
    border: '2px solid #A9A9A9',
    borderRadius: '15px 0px 15px 15px',
  },
  filterOptionsBox: {
    padding: '20px',
    background: '#EDEDED',
    minWidth: '500px',
  },
  btnCloseFiltersPopover: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: '0',
    paddingRight: '0',
  },
  paginationBox: {
    margin: '30px 0',
  },
});

const ProceduresPage = (props) => {
  const classes = useStyles();

  const proceduresAction = useStoreActions((actions) => actions.procedures);
  const commonAction = useStoreActions((actions)=>actions.common)
  const proceduresState = useStoreState((state) => state.procedures);

  const isProcedureInfoLoaded = useStoreState(
    (state) => state.procedures.isProcedureInfoLoaded,
  );
  const [opeAddUpdateDialog, setOpeAddUpdateDialog] = useState(false);
  const [dailogHeading, setDailogHeading] = useState('');
  const [currentRowData, setCurrentRowData] = useState({});
  const [dialogType, setDialogType] = useState('');
  const [listofCode, setListofCode] = useState([]);

  const [tableData, setTableData] = React.useState(false);
  const [filteredData, setFlteredData] = useState({
    name: '',
    status: 'ALL',
    code: 'ALL',
  });

  function resetFilters() {
    setFlteredData({
      name: '',
      status: 'ALL',
      code: 'ALL',    
    })
  }
  function handleInlineStatusChange(item) {
    try {

      let reqData = {
        PK: item.PK,
        SK: item.PK,
        current_status: item.current_status,
      };
      proceduresAction
        .updateProcedureStatus(reqData)
        .then(function (response) {
          // Now need to update the status in data
          let updatedData = tableData.map((item) => {
            if (item.PK == reqData.PK) {
              item.current_status = reqData.current_status;
              item.modify_date = moment()
            }
            return item;
          });
          updatedData = sortByField({
            data: updatedData,
            key: 'modify_date',
            secondKey: 'create_date',
          });
          setTableData(updatedData);
          proceduresAction.setProceduresList(updatedData);
          commonAction.setSubmitSnackbar({
            status: true,
            messages: stringConstants.updateMsg,
          });
        })
        .catch(function (error) {
            console.error(error)
            commonAction.setSubmitSnackbar({
              status: true,
              messages: 'Error updating the status',
              error: true,
            });
        });
    } catch (err) {
      console.error(err)
    }
  }
  const searchByKeyworld = (key, value) => {
    setFlteredData({ ...filteredData, [key]: value });
  };

  const filterList = [
    {
      type: 'droupdown',
      title: 'Status',
      value: filteredData.status,
      onChange: searchByKeyworld,
      searchKey: 'status',
      list: ['ALL', 'ACTIVE', 'INACTIVE'],
    },
    {
      type: 'droupdown',
      title: 'Type',
      value: filteredData.code,
      onChange: searchByKeyworld,
      searchKey: 'code',
      list: ['ALL', ...listofCode],
    },
  ];

  useEffect(() => {
    let newTableData = [...proceduresState.proceduresList];
    newTableData = newTableData.filter((data) => {
      return (
        (filteredData.name == '' ||
          data.record_number?.toLocaleLowerCase()
            .match(filteredData.name.toLocaleLowerCase()) ||
          data.title?.toLocaleLowerCase()
            .match(filteredData.name.toLocaleLowerCase()) ||
          data.category?.toLocaleLowerCase()
            .match(filteredData.name.toLocaleLowerCase())) &&
         (filteredData.status == 'ALL' || filteredData?.status?.toLocaleLowerCase() === data?.current_status?.toLocaleLowerCase()) &&
        (filteredData.code == 'ALL' || filteredData?.code?.toLocaleLowerCase() === data?.record_type?.toLocaleLowerCase())
      );
    });
    newTableData = sortByField({
      data: newTableData,
      key: 'modify_date',
      secondKey: 'create_date',
    });
    setTableData(newTableData);
  }, [proceduresState.proceduresList, filteredData]);
  useEffect(()=>{
    const record_type = [...(new Set(proceduresState.proceduresList.map(data=>data.record_type)))];
    setListofCode(record_type);
  },[proceduresState.proceduresList]);
  const breadcrumbsNav = [
    {
      title: 'Procedure Codes',
      link: '/procedures',
    },
  ];

  React.useEffect(() => {
    if (!isProcedureInfoLoaded) {
      proceduresAction
        .getProceduresList();
    }
  }, []);

  const loadMoreHandler = () => {
    proceduresAction.setProceduresList([]);
    // proceduresAction.setIsProcedureInfoLoaded(false);
    proceduresAction.setProcedures({});
    proceduresAction.getProceduresList()
      
  };

  //Click add form
  const addFormPopupHandler = (type, row = null) => {
    setOpeAddUpdateDialog(true);
    setDialogType(type);
    if (type === globalPageTypeEntity.add) {
      setDailogHeading('Add Procedure Code');
    } else {
      setCurrentRowData(row);
      setDailogHeading(
        `${type === globalPageTypeEntity.edit ? 'Edit' : 'View'} ${row?.title}`,
      );
    }
  };

  return (
    <Grid container direction="row">
      <DisplayBreadcrumbs items={breadcrumbsNav} />

      <Grid container direction="row" style={{ marginBottom: '50px' }}>
        <Grid container>
          <Grid item md={12} className={classes.filterContainer}>
            <Grid container>
              <Grid item md={4} style={{ display: 'flex' }} alignItems="center">
                Procedure Codes &nbsp;&nbsp;
              </Grid>

              <FilterSection
                filterList={filterList}
                keywordsPlaceholder="Enter Name/Code/Category"
                keywordskey="name"
                keywordsValue={filteredData.name}
                handleKeywordsChange={searchByKeyworld}
                resetFilters={resetFilters}
              />

              <Grid
                item
                md={4}
                alignItems="center"
                justifyContent="flex-end"
                style={{ display: 'flex' }}
              >
                {/* IH-4438: grey the icon only after the auto-fetch loop has settled with an exhausted cursor.
                    hasFetched gates the greyout so we don't grey on initial mount before the first page returns.
                    Stays clickable as a manual refresh affordance (and as the escape hatch when the 20-page cap was reached). */}
                <Tooltip title="Sync With Server" placement="bottom" arrow>
                  <IconButton
                    style={{
                      transform: 'rotate(90deg)',
                      color:
                        proceduresState.proceduresPagination?.hasFetched &&
                        !proceduresState.proceduresPagination?.next_page &&
                        !proceduresState.proceduresPagination?.capReached
                          ? '#A9A9A9'
                          : undefined,
                    }}
                    aria-label="Refresh"
                    onClick={loadMoreHandler}
                    disabled={proceduresState.isBatchLoading}
                    color="primary"
                  >
                    <SyncAltIcon />
                  </IconButton>
                </Tooltip>
                {proceduresState.isBatchLoading &&
                  tableData &&
                  tableData.length > 0 && (
                    <div>
                      <LightTooltip
                        title="Loading more procedure codes"
                        position="bottom"
                        arrow
                        open={proceduresState.isBatchLoading}
                      >
                        <IconButton
                          className={styles.spinner}
                          aria-label="Load More"
                          onClick={loadMoreHandler}
                          color="primary"
                        >
                          <AutorenewIcon />
                        </IconButton>
                      </LightTooltip>
                    </div>
                  )}

                
                  <Tooltip title="Add New">
                    <IconButton
                      color="primary"
                      aria-label="Add"
                      onClick={() => {
                        addFormPopupHandler(globalPageTypeEntity.add);
                      }}
                    >
                      <AddBoxIcon />
                    </IconButton>
                  </Tooltip>
              </Grid>
            </Grid>
          </Grid>

          <CustomListing
            tableData={tableData}
            isLoaded={false}
            entityType={globalAssoSearchListingTypeEntity.procedures}
            addFormPopupHandler={addFormPopupHandler}
            handleInlineStatusChange={handleInlineStatusChange}
          />

          <ProceduresAddUpdate
            open={opeAddUpdateDialog}
            heading={dailogHeading}
            onCloseDialog={() => {
              setOpeAddUpdateDialog(false);
            }}
            onChangeDialogType={() => {
              setDialogType(globalPageTypeEntity.edit);
              setDailogHeading(`Edit Procedure Code`);
            }}
            dialogType={dialogType}
            currentRowData={currentRowData}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ProceduresPage;
